import { JobQueue } from './JobQueue';

export const jobQueue = {
   list: JobQueue
}